// extracted by mini-css-extract-plugin
export default {"menu":"ProjectMenu_menu__+q3DR"};